export const CCounterFragments = {
  field: `
    fragment counter on counter_MatrixField {
      ... on counter_block_Entry {
        id
        typeHandle
        idName
        heading
        copy
        hyperlink {
          type
          url
          text
          target
        }
        button {
          type
          url
          text
          target
        }
      }
    }
  `,
}
